/* Empty href values are intentional placeholders pending final destination URLs. */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled, {  withTheme } from 'styled-components';
import Intl from '../common/Intl'
import { withAppContext } from 'src/store/initAppContext';
import { theme } from 'styled-tools';

const FooterSeoLinks = (props: any) => {

    const { app: { brandId }, theme } = props
    const { config: {showOnlyOnZpek,showOnlyOnCrypto, showOnlyOnFomo, showOnlyOnFun, showAllSports,showBlog,showPress,customercare, footerHelpUrl } } = theme;
    const brandUrlConfig: Record<number, string> = {
        33: 'https://m.iw247.com',
        39: 'https://www.fomo7.co',
        40: 'https://www.fomo7.co',
        46: 'https://www.fun88.live',
        47: 'https://www.fun88.live',
    };
    const brandUrl = brandUrlConfig[brandId] || 'https://www.yolo247.live';
    const [isOpen, setIsOpen] = useState(true);
    const otherProjectsUrl = (showOnlyOnCrypto || showOnlyOnZpek) ? "https://yolo247.games/" : showOnlyOnFomo ? "https://www.fomo7.games/" : showOnlyOnFun ? "https://www.fun88.games/" : "#";
    const appDownloadUrl = showOnlyOnFun ? "https://www.fun88.app" : showOnlyOnFomo ? "https://www.fomo7app.com/" : "";

    return (
        <UsefulLinksSection>
            <button
                className="usefulLinksToggle"
                type="button"
                aria-expanded={isOpen}
                aria-controls="footer-useful-links"
                onClick={() => setIsOpen((open) => !open)}
            >
                <span className='usefulLinksHead'><Intl langKey="FooterSeoLinks@USEFULLINKS" /></span>
                <span className={isOpen ? 'toggleIcon open' : 'toggleIcon'} aria-hidden="true" />
            </button>
            {isOpen && <FooterSeoLink id="footer-useful-links">
                <div className='seoLinkBlock'>
                    <div className='seoLinkBlockTittle'><Intl langKey="FooterSeoLinks@CASINO" /></div>
                    <ul>
                        <li><Link to="/live-casino"><Intl langKey="FooterSeoLinks@LIVECASINO" /></Link></li>
                        <li><Link to="/instant-games"><Intl langKey="FooterSeoLinks@INSTANTGAMES" /></Link></li>
                        <li><Link to="/slots"><Intl langKey="FooterSeoLinks@SLOT" /></Link></li>
                        <li><Link to="/popular-games"><Intl langKey="FooterSeoLinks@POPULARRGAMES" /></Link></li>
                        <li><Link to="/new-games"><Intl langKey="FooterSeoLinks@NEWGAMES" /></Link></li>
                    </ul>
                </div>
                <div className='seoLinkBlock'>
                    <div className='seoLinkBlockTittle'><Intl langKey="FooterSeoLinks@SPORTS" /></div>
                    <ul>
                        <li><Link to="/betting-exchange"><Intl langKey="FooterSeoLinks@BETTINGEXCHANGE" /></Link></li>
                        <li><Link to="/betting-exchange/cricket"><Intl langKey="RIGHTMENUSPORTS@CRICKET" /></Link></li>
                        <li><Link to="/betting-exchange/football"><Intl langKey="RIGHTMENUSPORTS@FOOTBALL" /></Link></li>
                        <li><Link to="/betting-exchange/tennis"><Intl langKey="RIGHTMENUSPORTS@TENNIS" /></Link></li>
                        <li><Link to="/premium-sportsbook"><Intl langKey="FooterSeoLinks@PREMIUMSPORTSBOOK" /></Link></li>
                        <li><Link to="/sportsbook">BTi Sports</Link></li>
                        <li><Link to="/saba-sports"><Intl langKey="TITLE@SabaSports" /></Link></li>
                        {showAllSports && <li><a href=""><Intl langKey="TITLE@AllSports" /></a></li>}
                    </ul>
                </div>
                <div className='seoLinkBlock'>
                    <div className='seoLinkBlockTittle'><Intl langKey="FooterSeoLinks@TOPGAMES" /></div>
                    {showOnlyOnCrypto ? (
                        <ul>
                            <li><Link to="/instant-games/spribe/aviator"><Intl langKey="TITLE@AVIATOR" /></Link></li>
                            <li><Link to="/instant-games/smartsoft/jetx"><Intl langKey="TITLE@JetX" /></Link></li>
                            <li><Link to="/instant-games/aviatrix/play-aviatrix"><Intl langKey="GAME@AVIATRIX" /></Link></li>
                            <li><Link to="/slots/jili-slot/super-ace"><Intl langKey="GAME@SUPERACE" /></Link></li>
                            <li><Link to="/slots/pgsoft/mahjong-ways"><Intl langKey="GAME@MAHJONGWAYS" /></Link></li>
                            <li><Link to="/slots/no-limit-city/book-of-shadows"><Intl langKey="GAME@BOOKOFSHADOWS" /></Link></li>
                            <li><Link to="/live-casino/evolution/crazy-time"><Intl langKey="TITLE@crazytime" /></Link></li>
                            <li><Link to="/live-casino/ezugi/roulette"><Intl langKey="TITLE@ROULETTE" /></Link></li>
                            <li><Link to="/live-casino/evolution/blackjack"><Intl langKey="TITLE@BLACKJACK" /></Link></li>
                            <li><Link to="/live-casino/betgames/baccarat"><Intl langKey="TITLE@BACCARAT" /></Link></li>
                            <li><Link to="/live-casino/evolution/dragon-tiger"><Intl langKey="TITLE@DragonTiger" /></Link></li>
                        </ul>
                    ) : (
                        <ul>
                            <li><Link to="/instant-games/spribe/aviator"><Intl langKey="TITLE@AVIATOR" /></Link></li>
                            <li><Link to="/instant-games/smartsoft/jetx"><Intl langKey="TITLE@JetX" /></Link></li>
                            <li><Link to="/instant-games/inout/chicken-road-2"><Intl langKey="TITLE@ChickenRoad2" /></Link></li>
                            <li><Link to="/instant-games/aviatrix/play-aviatrix"><Intl langKey="GAME@AVIATRIX" /></Link></li>
                            {!showOnlyOnFomo && <li><Link to="/instant-games/mines"><Intl langKey="TITLE@Mines" /></Link></li>}
                            {showOnlyOnFomo && <li><Link to="/live-casino/evolution/funky-time"><Intl langKey="TITLE@FunkyTimes" /></Link></li>}
                            <li><Link to="/instant-games/turbo-games/vortex"><Intl langKey="GAME@VORTEX" /></Link></li>
                            <li><Link to="/live-casino/evolution/crazy-time"><Intl langKey="TITLE@crazytime" /></Link></li>
                            {!showOnlyOnFomo && <li><Link to="/live-casino/dragon-tiger"><Intl langKey="TITLE@DragonTiger" /></Link></li>}
                            {!showOnlyOnFomo && <li><Link to="/live-casino/lightning-roulette"><Intl langKey="TITLE@LIGHTINGROULETTE" /></Link></li>}
                            <li><Link to="/slots/jili-slot/fortune-gems-2"><Intl langKey="GAME@FORTUNEGEMS2" /></Link></li>
                            <li><Link to="/slots/jili-slot/money-coming"><Intl langKey="GAME@MONEYCOMING" /></Link></li>
                            {showOnlyOnFomo && <li><Link to="/slots/jili-slot/legacy-of-egypt"><Intl langKey="TITLE@LegacyOfEgypt" /></Link></li>}
                            {showOnlyOnFomo && <li><Link to="/instant-games/galaxsys/tower-rush"><Intl langKey="GAME@TOWERRUSH" /></Link></li>}
                        </ul>
                    )}
                </div>
                <div className='seoLinkBlock'>
                    <div className='seoLinkBlockTittle'><Intl langKey="FooterSeoLinks@ABOUT" /></div>
                    <ul>
                        <li><Link to="/about/about-us"><Intl langKey="FooterSeoLinks@ABOUTK9" /></Link></li>
                        <li><Link to="/about/terms-conditions">1. <Intl langKey="FooterSeoLinks@TERMSCONDITIONS" /></Link></li>
                        <li><Link to="/about/privacy-policy">2. <Intl langKey="FooterSeoLinks@PRIVACYPOLICY" /></Link></li>
                        <li><Link to="/about/kyc-policy">3. <Intl langKey="FooterSeoLinks@KYCPOLICY" /></Link></li>
                        <li><Link to="/about/self-exclusion-policy">4. <Intl langKey="FooterSeoLinks@SELFEXCLUSIONPOLICY" /></Link></li>
                        <li><Link to="/about/aml-policy">5. <Intl langKey="FooterSeoLinks@AMLPOLICY" /></Link></li>
                        <li><Link to="/about/rules-regulations">6. <Intl langKey="FooterSeoLinks@BETTINGRULES" /></Link></li>
                        <li><Link to="/about/responsible-gambling">7. <Intl langKey="FooterSeoLinks@RESPONSIBLEGAMBLING" /></Link></li>
                         {!showOnlyOnFun && <li><Link to="/about/restricted-territories">8. <Intl langKey="FOOT@RESTRICTEDTERRITORIES" /></Link></li>}
                         {brandId && brandId !== 33 && <li><Link to="/sponsors"><Intl langKey="FooterSeoLinks@SPONSORSHIPS" /></Link></li>}
                         {showPress && <li><a href={`${brandUrl}/press/`}><Intl langKey="FooterSeoLinks@PRESS" /></a></li>}
                    </ul>
                </div>
                <div className='seoLinkBlock'>
                    <div className='seoLinkBlockTittle'><Intl langKey="FooterSeoLinks@PROMOTIONS" /></div>
                    <ul>
                        <li><Link to="/promotions/welcome-bonus"><Intl langKey="FooterSeoLinks@WELCOMEBONUS" /></Link></li>
                        <li><Link to="/promotions/refill-bonus"><Intl langKey="FooterSeoLinks@REFILLBONUS" /></Link></li>
                        <li><Link to="/promotions/referral-bonus"><Intl langKey="FooterSeoLinks@REFERRALBONUS" /></Link></li>
                        <li><Link to="/promotions/cashback-bonus"><Intl langKey="FooterSeoLinks@CASHBACKBONUS" /></Link></li>
                         {/* {(brandId !== 33 || showOnlyOnFomo) && <li><Link to="/promotions/weekly-deposits"><Intl langKey="FooterSeoLinks@WeeklyDeposits" /></Link></li>} */}
                    </ul>
                </div>
                <div className='seoLinkBlockLastWrap'>
                    <div className='seoLinkBlock'>
                        <div className='seoLinkBlockTittle'><Intl langKey="FooterSeoLinks@SUPPORT" /></div>
                        <ul>
                            <li><Link to="/about/faq"><Intl langKey="FooterSeoLinks@FAQ" /></Link></li>
                            {footerHelpUrl && footerHelpUrl !== "" && <li><a href={`${footerHelpUrl}`}><Intl langKey="FooterSeoLinks@HELP" /></a></li>}
                            {customercare && customercare !== "" && <li><a href={`${customercare}`}><Intl langKey="FooterSeoLinks@CONTACTUS" /></a></li> }
                            {(showBlog) && <li><a href={`${brandUrl}/blog/`}><Intl langKey="FooterSeoLinks@BLOG" /></a></li>}
                        </ul>
                    </div>
                    {otherProjectsUrl && otherProjectsUrl !== "#" && <div className='seoLinkBlock'>
                        <div className='seoLinkBlockTittle'><Intl langKey="FooterSeoLinks@OTHERPROJECTS" /></div>
                        <ul>
                            <li><a href={otherProjectsUrl}><Intl langKey="FooterSeoLinks@OTHERPROJECTS01" /></a></li>
                            {(brandId !== 33 && brandId !== 61) && <li><a href={appDownloadUrl}><Intl langKey="FooterSeoLinks@Fun88App" /></a></li>}
                        </ul>
                    </div>}
                </div>
            </FooterSeoLink>}
        </UsefulLinksSection>
    )
}

export default withTheme(withAppContext(FooterSeoLinks))

// Styled Components
const UsefulLinksSection = styled.section`
    width: 100%;
    max-width: 1400px;
    background: ${theme('palette.usefulLinksBg')};
    margin: 0 auto 0rem auto;

    .usefulLinksToggle {
        width: 100%;
        min-height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 0;
        padding: 0.5rem 1rem;
        color: #0F1115;
        background: ${theme('palette.usefulLinksToggleBg')};
        cursor: pointer;
        text-align: left;
    }

    .toggleIcon {
        width: 24px;
        height: 24px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
        color: ${theme('palette.usefulLinksToggleIconArrow')};
        background: ${theme('palette.usefulLinksToggleIconBg')};
    }

    .toggleIcon::before {
        width: 7px;
        height: 7px;
        border-top: 1px solid currentColor;
        border-left: 1px solid currentColor;
        content: '';
        transform: translateY(2px) rotate(45deg);
    }

    .toggleIcon:not(.open)::before {
        transform: translateY(-2px) rotate(225deg);
    }

    .usefulLinksHead {
        color: ${theme('palette.usefulLinksHeadColor')};
    }
`;

const FooterSeoLink = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    align-items: flex-start;
    gap: 2rem;
    padding: 2rem 3rem;
    background: ${theme('palette.usefulLinksBg')};

    .seoLinkBlock {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        color: #0F1115;
        text-align: left;
        /* width: 25%; */

        ul {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            margin: 0;
            padding: 0;
            list-style: none;

            li {
                font-size: 13px;

                &.seoLinkSubheading {
                    margin-top: 0.75rem;
                    font-weight: 700;
                }

                a {
                    width: auto;
                    padding: 0;
                    border-radius: 0;
                    color: ${theme('palette.usefulLinksColor')};
                    justify-content: flex-start;
                    text-transform: capitalize;

                    :hover {
                        color: ${theme('palette.usefulLinksColorHover')};
                        background-color: transparent;
                    }
                }
            }
        }
    }

    .seoLinkBlockTittle {
        color: ${theme('palette.seoLinkBlockTittleColor')};
        text-transform: capitalize;
        font-weight: 700;
        font-size: 16px;
        text-align: left;
    }

    .seoLinkBlockLastWrap {
        display: flex;
        flex-direction: column;
        gap: 30px;
    }

    @media (max-width: 900px) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    @media (max-width: 600px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 1.5rem 1rem;
        padding: 1.5rem 1rem;
    }
`;
